'use client';
import {useState} from 'react';
import {handleLogin, loginState} from '@/utils/event/util';
import globalDomains from '@/utils/global-domains';
import {motion} from 'framer-motion';
import styles from './style.module.scss';

const SavygEventApply = () => {
  const [isActive, setIsActive] = useState(false);
  const [isNoticeOpen, setIsNoticeOpen] = useState(false);

  const toggleActive = () => {
    setIsActive((prev) => !prev);
  };

  const toggleNotice = () => {
    setIsNoticeOpen((prev) => !prev);
  };

  const handleClickSavygCreate = () => {
    window.open(
      `${globalDomains.WWW_AFREECATV}/ai/savyg`,
      '_blank',
      'width=768,height=857',
    );
  };

  const handleSavygPage = () => {
    window.open(`${globalDomains.WWW_AFREECATV}/ai/savyg/archive`);
  };

  return (
    <div id={styles.wrap}>
      <header className={styles.header}>
        <div className={styles.inner}>
          <h1>
            <a href={`${globalDomains.WWW_AFREECATV}`} target='_blank'>
              SOOP
            </a>
          </h1>
          <div className={styles.login_wrap}>
            {loginState ? (
              <>
                <button
                  type='button'
                  className={styles.logout}
                  onClick={handleLogin}>
                  로그아웃
                </button>
              </>
            ) : (
              <button
                type='button'
                className={styles.login}
                onClick={handleLogin}>
                로그인
              </button>
            )}
          </div>
        </div>
      </header>

      <div className={styles.visualArea}>
        <div className={styles.inner}>
          <div className={styles.title_box}>
            <h3>
              <span>나도, 스트리머도 행복한 1+1 경품</span>
              숲 AI 영상 콘테스트 개최! <br /> 나도, 스트리머도 행복한 1+1 경품
            </h3>
          </div>
          <div className={styles.btn_area}>
            <button
              type='button'
              className={styles.btn_visual}
              onClick={handleClickSavygCreate}>
              지금 SAVYG 영상 만들어보기
            </button>
            <button
              type='button'
              className={styles.btn_savyg}
              onClick={handleSavygPage}>
              SAVYG 페이지 구경가기
            </button>
          </div>
        </div>
      </div>
      <section className={styles.section2}>
        <div className={styles.inner}>
          <div className={styles.title_box}>
            <motion.h3
              className={styles.title}
              initial={{y: 60, opacity: 0}}
              whileInView={{y: 0, opacity: 1}}
              transition={{duration: 0.3}}
              viewport={{once: true}}>
              내가 좋아하는 스트리머로 재밌는 영상을 만들고 선물까지 같이 받자!
            </motion.h3>
          </div>
          <motion.div
            className={styles.cont_box}
            initial={{y: 60, opacity: 0}}
            whileInView={{y: 0, opacity: 1}}
            transition={{duration: 0.3, delay: 0.3}}
            viewport={{once: true}}>
            <p>
              SAVYG 으로 스트리머 AI 영상 만들면 나랑 스트리머 나란히 1+1 경품
              받기
            </p>
          </motion.div>
        </div>
      </section>
      <section>
        <div className={styles.section3_cont_wrap}>
          <div className={styles.cont_1}>
            <div className={styles.inner}>
              <div className={styles.title_box}>
                <motion.h3
                  className={styles.title}
                  initial={{y: 60, opacity: 0}}
                  whileInView={{y: 0, opacity: 1}}
                  transition={{duration: 0.3}}
                  viewport={{once: true}}>
                  <span>나랑 스트리머 나란히 1+1</span> 지금, 엄청난 경품에
                  도전해보세요!
                </motion.h3>
              </div>
              <motion.div
                className={styles.cont_box}
                initial={{y: 60, opacity: 0}}
                whileInView={{y: 0, opacity: 1}}
                transition={{duration: 0.3, delay: 0.3}}
                viewport={{once: true}}>
                <ul>
                  <li>
                    <em>대상</em>
                    <span>닌텐도 스위치 2(1팀)</span>
                  </li>
                  <li>
                    <em>최우수상</em>
                    <span>SOOP 크레딧 20만원 (2팀)</span>
                  </li>
                  <li>
                    <em>SOOP 크레딧 5만원 (5팀)</em>
                  </li>
                </ul>
              </motion.div>
            </div>
          </div>
          <div className={styles.cont_2}>
            <div className={styles.inner}>
              <div className={styles.title_box}>
                <motion.h3
                  className={styles.title}
                  initial={{y: 60, opacity: 0}}
                  whileInView={{y: 0, opacity: 1}}
                  transition={{duration: 0.3}}
                  viewport={{once: true}}>
                  <span>어디서든 SAVYG 영상 만들기만 하면 끝!</span> 지금 여기서
                  만들어도 참여 가능해요!
                </motion.h3>
              </div>
              <div className={styles.rolling_box}>
                <div className={styles.rolling_item}></div>
              </div>
              <button type='button' onClick={handleClickSavygCreate}>
                바로 SAVYG 영상 만들기
              </button>
            </div>
          </div>
          <div className={styles.cont_3}>
            <div className={styles.inner}>
              <div className={styles.title_box}>
                <motion.h3
                  className={styles.title}
                  initial={{y: 60, opacity: 0}}
                  whileInView={{y: 0, opacity: 1}}
                  transition={{duration: 0.3}}
                  viewport={{once: true}}>
                  <span>SOOP 유저라면 누구나 </span>
                  싸빅 영상 만들기만 하면 무제한 응모 가능
                </motion.h3>
                <p>SOOP 속 어디서든 콘테스트 참여할 수 있어요</p>
              </div>
              <div className={styles.step_list_wrap}>
                <div
                  className={`${styles.step_box} ${isActive ? styles.active : ''}`}>
                  <div className={styles.box_inner}>
                    <div className={styles.cont_box1}>
                      <span>스텝1</span>
                      <p>싸빅 아카이브 페이지에서 AI 영상 만들기를 시작</p>
                      <ul>
                        <li>1.홈 메뉴 내 [AI 영상 만들기] 클릭</li>
                        <li>2.[AI 영상 만들기] 혹은 [+] 버튼 클릭</li>
                      </ul>
                    </div>
                    <div className={styles.cont_box2}>
                      <div>
                        <p>Live 방송 참여 중 바로 만들어서 보내고 싶다면?</p>
                        <ul>
                          <li>선물하기 - 별풍선</li>
                          <li>선물하기 - 별풍선</li>
                        </ul>
                      </div>
                      <div>
                        <p>스트리머가 직접 멋진 영상을 만들어 보고 싶다면?</p>
                        <ul>
                          <li>프릭샷 / 프릭샷 플러스에서 AI 영상 만들기</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className={styles.more_box}>
                    <span>SAVYG 영상을 만들 수 있는 루트가 더 있어요!</span>
                    <button type='button' onClick={toggleActive}>
                      {isActive ? '접기' : '더보기'}
                    </button>
                  </div>
                </div>
                <div className={styles.step_box}>
                  <div className={styles.box_inner}>
                    <div className={styles.cont_box3}>
                      <span>스텝2</span>
                      <p>
                        스트리머를 지정하고 해당 스트리머의 이미지를 업로드해
                        재밌는 영상 만들기
                      </p>
                      <ul>
                        <li>1.스트리머 & 스타일 선택</li>
                        <li>
                          2. (스타일 적용 단계 이후) 선택한 스트리머 이미지
                          업로드
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className={styles.step_box}>
                  <div className={styles.box_inner}>
                    <div className={styles.cont_box4}>
                      <span>스텝3</span>
                      <p>영상 만들고 방송국에 업로드 되면 자동 응모 완료!</p>
                      <ul>
                        <li>1.AI 영상 제작 완료</li>
                        <li>2.방송국 업로드 확인</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className={styles.tip_box}>
                  <ul>
                    <li>영상 만들 때마다 당첨 확률 UP! 중복 응모 가능!</li>
                    <li>
                      만든 영상을 영상풍선으로 후원하면 당첨 확률 한번 더 UP!
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={styles.section4}>
        <div className={styles.inner}>
          <div className={styles.title_box}>
            <motion.h3
              className={styles.title}
              initial={{y: 60, opacity: 0}}
              whileInView={{y: 0, opacity: 1}}
              transition={{duration: 0.3}}
              viewport={{once: true}}>
              <span>숲 AI 콘테스트 어떤 콘테스트냐구요?</span>
              SOOP 유저라면 누구나! 어떤 주제든 자유롭게!
              <p>단, SAVYG 이용 규칙에 어긋나는 영상은 심사에서 제외됩니다.</p>
            </motion.h3>
            <ul>
              <li>
                <span>이벤트 기간</span>
                10월 30일(목) - 11월 25일(금)
              </li>
              <li>
                <span>당첨작발표</span>
                12월 03일(수)
              </li>
            </ul>
          </div>
          <motion.div
            className={styles.cont_box}
            initial={{y: 60, opacity: 0}}
            whileInView={{y: 0, opacity: 1}}
            transition={{duration: 0.3, delay: 0.3}}
            viewport={{once: true}}>
            <div className={styles.cont_box}>
              <strong>심사기준</strong>
              <ul>
                <li>
                  <span>창의성</span>
                  <p>얼마나 차별화 되고 신선한가?</p>
                </li>
                <li>
                  <span>완성도</span>
                  <p>작품의 완성도와 심미성이 얼마나 높은가?</p>
                </li>
                <li>
                  <span>재미</span>
                  <p>사람들에게 얼마나 즐거움을 선사하는가?</p>
                </li>
                <li>
                  <span>생성 건수</span>
                  <p>해당 영상을 생성한 유저의 생성 건수가 많을 수록</p>
                </li>
                <li>
                  <span>후원 건수</span>
                  <p>해당 영상으로 후원된 건수가 많을 수록</p>
                </li>
                <li>
                  <span>조회수</span>
                  <p>해당 영상의 조회수가 높을 수록</p>
                </li>
              </ul>
            </div>
          </motion.div>
          <motion.div
            className={styles.btn_box}
            initial={{y: 60, opacity: 0}}
            whileInView={{y: 0, opacity: 1}}
            transition={{duration: 0.3, delay: 0.3}}
            viewport={{once: true}}>
            <p>재밌는 영상 만들고, 스트리머에게 선물까지!</p>
            <button type='button' onClick={handleClickSavygCreate}>
              콘테스트 응모하기
            </button>
          </motion.div>
        </div>
      </section>

      <div
        className={`${styles.notice_area} ${isNoticeOpen ? styles.active : ''}`}>
        <div className={styles.inner}>
          <button type='button' onClick={toggleNotice}>
            <strong className={styles.title}>
              이벤트 <em>유의사항</em>
            </strong>
          </button>

          <ul className={styles.list}>
            <li>
              이벤트 기간, 응모 방법, 경품 내용, 당첨자 발표 일정은 사전 공지된
              내용에 따릅니다.
            </li>
            <li>
              당첨자가 제공한 개인정보가 허위이거나, 자동 프로그램·타인 정보
              도용 등 부정한 방법으로 응모한 사실이 확인될 경우 당첨은 취소되며
              경품은 회수될 수 있습니다.
            </li>
            <li>
              1인 다회 응모 가능하나 동일 계정 다수 당첨 시 1건만 인정됩니다.
            </li>
            <li>
              경품은 사정에 따라 동등한 가치의 다른 상품으로 대체될 수 있습니다.
            </li>
            <li>
              운영 정책 위반 또는 부정한 방법으로 이벤트 참여시 당첨에서 제외될
              수 있습니다.
            </li>
            <li>
              잘못된 정보로 상품을 받지 못한 경우 재발송해 드리지 않습니다.
            </li>
            <li>
              이벤트 당첨자는 개별 안내 예정이며, 당첨자와 연락이 어려운 경우
              상품 지급이 불가하오니 사전에 쪽지 수신 거부 해제 바랍니다.
            </li>
            <li>
              프로모션 기간 이전 제작한 영상은 응모 내역에 포함되지 않습니다.
            </li>
            <li>
              소득세법 제21조 및 제84조 제2항 제3호 등에 따라 5만원을 초과하는
              경품이나 상금의 경우 상품 금액의 22% 제세공과금을 지불해야 합니다.
            </li>
            <li>
              이벤트 참여 과정에서 수집된 개인정보는 당첨자 확인 및 경품 발송,
              세무 처리 목적으로만 이용되며, 보유 기간 종료 후 파기됩니다.
            </li>
            <li>
              안내 드린 기한 내 제세공과금을 납부하지 않으면 당첨이 취소될 수
              있습니다.
            </li>
            <li>
              당첨자의 계정 명의와 신분증, 제세공과금 납부자의 명의가 모두
              일치해야 경품이 정상적으로 배송됩니다. 명의가 일치하지 않을 경우,
              당첨이 취소될 수 있으니 반드시 확인 부탁드립니다.
            </li>
            <li>
              경품 양도·판매·환전은 불가하며, 이를 위반할 경우 발생하는 모든
              책임은 당첨자 본인에게 있습니다.
            </li>
            <li>
              당첨자 발표 및 상품 지급일은 당사 사정에 의해 변경될 수 있습니다.
            </li>
            <li>본 이벤트는 당사 사정에 의해 조기 종료될 수 있습니다.</li>
          </ul>
        </div>
      </div>

      <footer className={styles.footer}>ⓒ SOOP Corp.</footer>
    </div>
  );
};

export default SavygEventApply;
